import { ApplicationState } from '../domain/types';
import { ApplicationStateResponse } from '../domain/types/applicationState';
import { AuthenticationData } from '../store/authentication';
import { apiClient } from './apiClient';

type Role = 'MAIN' | 'CO';

export const applicationStateMap = (state: ApplicationState, role: Role): ApplicationState => {
    switch (state) {
        case 'CO_SUBMIT':
            return role === 'CO' ? 'CO_SUBMIT' : 'WAITING_FOR_CO_APPLICANT';

        case 'KYC_CO_APPLICANT':
            return role === 'CO' ? 'KYC_CO_APPLICANT' : 'WAITING_FOR_CO_APPLICANT';

        case 'ACCEPT_OFFER_MAIN_APPLICANT':
            return role === 'MAIN' ? 'ACCEPT_OFFER_MAIN_APPLICANT' : 'WAITING_FOR_MAIN_APPLICANT';

        case 'DISBURSEMENT_ACCOUNT_INFORMATION_MAIN_APPLICANT':
            return role === 'MAIN' ? 'DISBURSEMENT_ACCOUNT_INFORMATION_MAIN_APPLICANT' : 'WAITING_FOR_MAIN_APPLICANT';

        case 'PPI_MAIN_APPLICANT':
            return role === 'MAIN' ? 'PPI_MAIN_APPLICANT' : 'WAITING_FOR_MAIN_APPLICANT';

        case 'COMPLEMENT_INFORMATION_CONSOLIDATIONS':
            return role === 'MAIN' ? 'COMPLEMENT_INFORMATION_CONSOLIDATIONS' : 'WAITING_FOR_MAIN_APPLICANT';

        case 'KYC_MAIN_APPLICANT':
            return role === 'MAIN' ? 'KYC_MAIN_APPLICANT' : 'WAITING_FOR_MAIN_APPLICANT';

        case 'SIGN_AGREEMENT':
            return 'SIGN_AGREEMENT';

        default:
            return state;
    }
};

export const getApplicationStateService = async (
    proxyBaseUrl: string,
    apiKey: string,
    arn: string | undefined,
    authenticationData?: AuthenticationData,
): Promise<ApplicationStateResponse> => {
    const response = await apiClient<{ state: ApplicationState; applicantRole: Role }>(
        `${proxyBaseUrl}/application/${arn}/state`,
        {
            method: 'GET',
            apiKey,
            authenticationData,
            sentryTag: 'get_application_state',
            sentryExtra: { arn },
        },
    );
    return { state: applicationStateMap(response.state, response.applicantRole) };
};
